import React from "react";
import t from "../../../../i18n";
import ModalForm from "@ui/Modal/Form";
import Text from "@ui/Text";
import { usePost } from "../../../../api/useCall";

interface P {
  projectId: string;
  onRequestClose: () => void;
}

const DataFlowPausedModalForm = ({ projectId, onRequestClose }: P) => {
  const updateDataFlowActivation = usePost("/projects/:projectId(uuid)/analyses/activationFlow");

  const handleSubmit = React.useCallback(async () => {
    await updateDataFlowActivation({
      routeParams: { projectId },
      body: { activationStatus: false },
    });
    return true;
  }, [projectId, updateDataFlowActivation]);

  return (
    <ModalForm
      onSubmit={handleSubmit}
      onRequestClose={onRequestClose}
      okButtonName={t("modalForm.button.name.pause")}
      okButtonVariant="destructive"
    >
      <Text>{t("project.settings.modal.data_flow.disabled.text")}</Text>
    </ModalForm>
  );
};

export default React.memo(DataFlowPausedModalForm);
